/**
 * @fileOverview This file contains the implementation of the Delete Item Modal component for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Diego Benítez Reyna
 */

import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import customAxios from '../../utils/customAxios';
import {getToast} from '../../utils/toastConfig';
import { GlobalVariables } from '../../globalVar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useTranslationHook } from '../../hooks/UseTranslationHook';

const DeleteItemModal = ({show, setShow, refreshItems, itemData}) => {
    const {
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    const [isLoading, setIsLoading] = useState(false);

    const deleteItem = async(e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const updateRes = await customAxios.patch(`${GlobalVariables.getURL()}items/update/${itemData.item_id}`, {
                is_active: 2
            }, {
                headers: {
                    Authorization: 'bearer ' + localStorage.getItem('token'),
                }
            });

            getToast({status: 'success', title: 'Refacción eliminada correctamente'});
            setIsLoading(false);
            hideModal();
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            getToast({status: 'error', title: error.response.data.message});
        }
    }

    const hideModal = () => {
        refreshItems();
        setShow();
    }

    return (
        <Modal
            show={show}
            onHide={hideModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {'¿Quieres borrar esta refacción?'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <span className='delete-info'><strong>Refacción:</strong> {itemData.item_name}</span>
                    <span className='delete-info'><strong>Código:</strong> {itemData.code}</span>
                    <span className='delete-info'><strong>Modelo:</strong> {itemData.model}</span>
                    <span className='delete-info'><strong>Almacén:</strong> {itemData.inventory_type_name}</span>
                    <span className='delete-info'><strong>Ubicación:</strong> {itemData.default_ubication}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' disabled={isLoading} onClick={(e) => {deleteItem(e)}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideModal()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteItemModal